import { safeboxClient, authClientRequiredToken } from 'myNet'
import { getEnvParam } from 'env'
import { isGlobal } from 'conf'
import store from 'store'

const METHOD = {
  GET: 'get',
  POST: 'post',
}

function apiRequest(client, method, url, data = null, params = null, resolveDataOnly = true) {
  return new Promise((resolve, reject) => {
    const request = method === METHOD.POST ? client.post(url, data) : client.get(url, params)

    request
      .then((res) => {
        resolve(resolveDataOnly ? res.data : res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getMyInfo() {
  return apiRequest(safeboxClient, METHOD.GET, '/v1/users/me', null, null, true)
}

export function getMyRecoveryStatus() {
  return apiRequest(safeboxClient, METHOD.GET, '/v1/users/me/recovery/status', null, null, true)
}

export function getMyAvatar() {
  return apiRequest(safeboxClient, METHOD.GET, '/v1/user_avatar/me/avatar', null, null, true)
}

export function getWorkspacesByEmail() {
  return apiRequest(safeboxClient, METHOD.GET, '/v1/users/workspaces/by-email', null, null, false)
}

export function getAuthInfo() {
  return apiRequest(safeboxClient, METHOD.GET, '/v1/auth/info', null, null, false)
}

export function getCommonAuthWorkspaceInfo() {
  return apiRequest(authClientRequiredToken, METHOD.GET, '/workspace/info', null, null, false)
}

export function selectWorkspace(workspaceId) {
  return apiRequest(
    safeboxClient,
    METHOD.POST,
    '/v1/users/select-workspace',
    { workspace_id: workspaceId },
    null,
    false,
  )
}

export function getWorkspaceInfo() {
  const inviteType = JSON.parse(getEnvParam('inviteType') || '{}')
  const workspaceId = store.get('app.user.workspace_id') || inviteType.workspace_id

  const promise = new Promise((resolve, reject) => {
    authClientRequiredToken
      .get(isGlobal() ? `/workspace/info-jp` : `/workspace/info`, { workspace_id: workspaceId })
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })

  return promise
}

export function getPaidLicense() {
  return apiRequest(safeboxClient, METHOD.GET, '/v1/workspaces/license', null, null, true)
}
